import moment from 'moment';
import {getTimeZoneName} from './common';

export const SIMILAR_WINDOW_DAYS = 30;
const UTC_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * The similar-messages window: from 00:00 of the day SIMILAR_WINDOW_DAYS days before today up to 23:59:59 of
 * today, in the user's timezone, as UTC strings. Everything reported today is always inside the window.
 */
export const getSimilarWindow = () => {
  const tzName = getTimeZoneName();
  const now: any = moment();
  const today = typeof now.tz === 'function' && tzName ? now.tz(tzName) : now;
  return {
    startDate: today.clone().startOf('day').subtract(SIMILAR_WINDOW_DAYS, 'days').utc().format(UTC_FORMAT),
    endDate: today.clone().endOf('day').utc().format(UTC_FORMAT),
  };
};
